<template>
  <span :style="computedStyle" class="product-list__bullet" />
</template>
<script lang="ts">
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BulletAsset extends Vue {
  @Prop({ type: String, default: NebraskaColors.textPrimary })
  private color!: string;

  public get computedStyle() {
    return { backgroundColor: this.color };
  }
}
</script>
<style lang="less" scoped>
.product-list__bullet {
  min-width: @size-spacing-x350;
  min-height: @size-spacing-x350;
  border-radius: @size-radius-x200;
  display: inline-block;
}
</style>
